module.exports = __webpack_public_path__ + "img/dz.7dabf82c.svg";